"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/auth/current");
const LoginActionTypes = require("../../actionTypes/auth/login");
exports.initialState = {
    token: '',
    status: 'STANDBY',
    featureStatus: 'STANDBY',
    features: [],
    user: fp.option.none,
    error: undefined
};
const tokenLens = monocle.Lens.fromProp('token');
const statusLens = monocle.Lens.fromProp('status');
const featureStatusLens = monocle.Lens.fromProp('featureStatus');
const featuresLens = monocle.Lens.fromProp('features');
const userLens = monocle.Lens.fromProp('user');
const errorLens = monocle.Lens.fromProp('error');
exports.methods = {};
exports.methods[ActionTypes.GET_USERINFO_REQUEST] = (state, action) => fp.function.compose(statusLens.set('FETCHING'), errorLens.set(undefined))(state);
exports.methods[ActionTypes.GET_USERINFO_FAILURE] = (state, action) => fp.function.compose(statusLens.set('FAILED'), errorLens.set(action.payload))(state);
exports.methods[ActionTypes.GET_USERINFO_SUCCESS] = (state, action) => fp.function.compose(statusLens.set('FETCHED'), userLens.set(fp.option.some(action.payload)))(state);
exports.methods[ActionTypes.FETCH_USER_FEATURES_REQUEST] = (state, action) => featureStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.FETCH_USER_FEATURES_FAILURE] = (state, action) => featureStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.FETCH_USER_FEATURES_SUCCESS] = (state, action) => fp.function.compose(featureStatusLens.set('FETCHED'), featuresLens.set(action.payload))(state);
exports.methods[ActionTypes.UPDATE_USER_LANGUAGE] = (state, action) => {
    return Object.assign(Object.assign({}, state), { user: fp.option.map((user) => (Object.assign(Object.assign({}, user), { language: action.payload })))(state.user) });
};
// SET TOKEN
exports.methods[ActionTypes.REFRESH_TOKEN_SUCCESS] = (state, action) => tokenLens.set(action.payload)(state);
exports.methods[LoginActionTypes.LOGIN_SUCCESS] = (state, action) => tokenLens.set(action.payload)(state);
exports.methods[LoginActionTypes.EXCHANGE_CODE_FOR_TOKENS_SUCCESS] = (state, action) => tokenLens.set(action.payload)(state);
exports.methods[LoginActionTypes.LOGOUT] = () => (Object.assign({}, exports.initialState));
//# sourceMappingURL=current.js.map